import React from 'react';

export type RunContextProps = {
    setTitle: (title: string) => void,
};

const RunContext: React.Context<RunContextProps> = React.createContext<RunContextProps>({
    setTitle: () => {},
});

export default RunContext;